import { render, staticRenderFns } from "./ProofreadingCategoryAccordion.vue?vue&type=template&id=764218de&scoped=true"
import script from "./ProofreadingCategoryAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProofreadingCategoryAccordion.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProofreadingCategoryAccordion.vue?vue&type=style&index=0&id=764218de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764218de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764218de')) {
      api.createRecord('764218de', component.options)
    } else {
      api.reload('764218de', component.options)
    }
    module.hot.accept("./ProofreadingCategoryAccordion.vue?vue&type=template&id=764218de&scoped=true", function () {
      api.rerender('764218de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/shared/ProofreadingCategoryAccordion.vue"
export default component.exports